import { useModals } from '~/contexts/ModalsContext';
import { useSession } from '~/contexts/SessionContext';
import { useSavedSearchContext } from '~/contexts/SavedSearchContext';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';
import { createSavedSearch, deleteSavedSearch } from '~/api/savedSearch';
import filterStateToPageTitle from '~/utils/filterStateToPageTitle';
import filterStateToQueryString from '~/utils/filterStateToQueryString';
import { useRouter } from 'next/router';
import { useState } from 'react';

export default function useSavedSearch() {
  const router = useRouter();
  const modals = useModals();
  const session = useSession();
  const { savedSearch } = useSavedSearchContext();
  const { facets, filterState } = useFacetFiltering();
  const [isLoading, setIsLoading] = useState(false);

  async function makeSavedSearch() {
    try {
      setIsLoading(true);
      const r = await createSavedSearch(
        filterStateToPageTitle(facets, filterState),
        filterState,
      );

      modals.openModal('editSavedSearch', {
        recentlyCreated: true,
        savedSearch: r,
      });

      await router.push(`/search?saved_search_id=${r.id}`);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  }

  function loggedOutMakeSavedSearch() {
    if (session.loggedIn) {
      makeSavedSearch();
    } else {
      modals.openModal('loginRegister', {
        onSuccessfulLogin: makeSavedSearch,
        src: 'saved-search',
        contextMessage: 'Join SidelineSwap to receive updates on this search',
      });
    }
  }

  async function unfollowSavedSearch() {
    try {
      setIsLoading(true);
      if (savedSearch) {
        await deleteSavedSearch(savedSearch.id);
        await router.push(
          `/search${filterStateToQueryString(filterState, [
            'saved_search_id',
          ])}`,
        );
      }
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  }

  async function toggleSavedSearch() {
    if (savedSearch) {
      await unfollowSavedSearch();
    } else {
      await loggedOutMakeSavedSearch();
    }
  }

  return {
    isLoading,
    toggleSavedSearch,
    savedSearch,
  };
}
